export const MeetupAPI = {
    apiKey : "5035635145307a15858b7974232226",
    urlname: "GDG-Ilorin"
}